import Route from '@ember/routing/route';

export default class NensaClassesRoute extends Route
{
	model()
	{
		return this.modelFor("event");
	}
}
